<div class="social-proof">
  <div class="social-proof-graph" *ngIf="kind !== '3a'">
    <div class="social-demo">
      <div class="social-demo-tooltip" [style.left]="knobPosition">Avg. {{savingsPlanSocialProof?.average | thousand: currency}}</div>
      <div class="social-demo-knob" [style.left]="knobPosition"></div>
    </div>
    <p
      [innerHTML]="'sp.revamp.socialProof.description' | translate: {
      percentage: savingsPlanSocialProof?.percentage | percent: '1.0-1',
      below_avg: savingsPlanSocialProof?.below_average | thousand: currency,
      above_avg: savingsPlanSocialProof?.above_average  | thousand: currency}"
    ></p>
  </div>
  <div class="social-proof-expand">
    <a href="javascript:;" (click)="onToggleDetails()">
      {{(showDetails ? 'sp.revamp.assetGraph.collapse' : 'sp.revamp.assetGraph.expand') | translate}}
    </a>
  </div>
  <div *ngIf="showDetails" class="social-proof-details">
    <h2>{{'sp.revamp.assetGraph.legend.title' | translate}}</h2>
    <p
      [innerHTML]="(kind !== '3a' ? 'sp.revamp.assetGraph.legend.difference.years' : 'sp.revamp.3a.legend.summary') | translate: {
      years: estimatedPeriod, difference: difference.toFixed(0) | thousand: currency
    }"
    ></p>
    <p
      [innerHTML]="'sp.revamp.assetGraph.legend.probability' | translate: {
      loss: expectedPercentages.loss | percent:'1.0-1',
      gain: expectedPercentages.good | percent:'1.0-1',
      expected: expectedPercentages.expected | percent:'1.0-1'}"
    ></p>
    <div class="social-proof-calculation">
      <img src="../../../../assets/icon/assets-info.svg" alt="Assets Info Icon" />
      <p><strong>{{'sp.revamp.assetGraph.legend.subtitle' | translate}}</strong></p>
    </div>
    <p>{{'sp.revamp.assetGraph.legend.model' | translate}}</p>
  </div>
</div>
